module.exports = __webpack_public_path__ + "img/AtaMuhammad-Bebash.67ce8199.jpg";